import { OccupancyRateAPI } from "@/api/occupancyRateAPI";
import {
  GET_MPI_ELEMENT_ERROR,
  GET_MPI_ELEMENT_REQUEST,
  GET_MPI_ELEMENT_SUCCESS,
} from "@/redux/actions";
import { call, put, takeLatest } from "redux-saga/effects";

function* workerMpiElement(action: {
  type: string;
  payload: string[];
}): Generator<any> {
  try {
    const response: any = yield call(
      OccupancyRateAPI.getMpiElement,
      action.payload
    );

    yield put({
      type: GET_MPI_ELEMENT_SUCCESS,
      payload: response.data[0],
    });
  } catch (error) {
    yield put({ type: GET_MPI_ELEMENT_ERROR, payload: error });
  }
}

export function* watcherMpiElement() {
  yield takeLatest(GET_MPI_ELEMENT_REQUEST, workerMpiElement);
}
